import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { Provide, Options } from 'vue-property-decorator';
import { API_URL, TOKEN_REFRESH_TIME } from './config/config';
import { Vue } from 'vue-class-component';
import AuthenticationService from './modules/authentication/authentication.service';
import store from './store';
import * as HttpStatus from 'http-status-codes';
import { RouteN } from './constants/router-name';
import { AuthorizedUser } from './models/authorized-user';
import { EventEmitter } from 'events';
import SnackBar from "@/shared/components/snackbar/index.vue";
import { TrustAPI } from '@/shared/modules/trust-api';
import ConfirmDialogue from '@/shared/components/confirm-dialogue/index.vue';


@Options<App>({
  components: {
    SnackBar,
    ConfirmDialogue,
  }
})
export default class App extends Vue {

  private apiAxios?: AxiosInstance;
  private authApiAxios?: AxiosInstance;
  private gettingToken?: boolean;
  private authService?: AuthenticationService;
  private authorizedUser: AuthorizedUser = new AuthorizedUser;

  @Provide({ to: 'apiService', reactive: true })
  private apiService: TrustAPI = new TrustAPI();

  @Provide({ to: 'eventController', reactive: true })
  private eventCtrl: EventEmitter = new EventEmitter();

  created(): void {
    this.authorizedUser = store.getters.getUserAccount;
    this.authService = new AuthenticationService(this.authorizedUser, this.authApiAxios);
    this.gettingToken = false;
    this.apiAxios = axios.create();
    this.authApiAxios = axios.create();

    this.apiAxios.interceptors.request.use(async (config: AxiosRequestConfig) => {

      const refreshToken = (this.authorizedUser.session.issued + TOKEN_REFRESH_TIME)
        < Math.round(new Date().getTime() / 1000) && !this.gettingToken;

      while (this.gettingToken) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      try {
        if (refreshToken) {
          this.gettingToken = true;
          this.authorizedUser.token.tokenStr = '';
          await this.authService?.checkAuthentication();
          this.gettingToken = false;
        }

        if (config.headers === undefined) {
          config.headers = {};
        } else {
          config.headers.Authorization = 'bearer ' + this.authorizedUser.token.tokenStr;
        }

        return Promise.resolve(config);
      } catch (err) {
        this.gettingToken = false;
        return Promise.reject(config);
      }

    });

    this.apiAxios.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      if (error.response?.status == 400 && error.response.data?.errorCode == 10001) {
        // handle by resubmit handler
        this.confirmResubmitRequest();
      } else {
        this.eventCtrl.emit('show-snackbar', 'error', 'Network error: ' + error.message);
      }
      if (error.response.status === HttpStatus.UNAUTHORIZED) {
        document.location.href = RouteN.ATCS.LoginPage.p + '?redirect=' + this.$route.fullPath;
      }
      return Promise.reject(error);
    });

    this.apiService = new TrustAPI(undefined, API_URL, this.apiAxios);
  }

  get store(): any {
    return store;
  }

  private confirmResubmitRequest(): void {
    const _route: string = this.$route.name as string;
    const _isEE = _route.indexOf('atcs-ee-home') > -1 || _route.indexOf('atcs-form-eer') > -1;
    const _confirm: any = this.$refs.confirmResubmitRequest;
    _confirm.show({
      title: 'Stop',
      message: 'Compliance form has been updated by the trust admin',
      okButton: 'OK',
      cancelButton: '',
    }).then((res: any) => {
      if (res) {
        if (_isEE) {
          this.$router.push({ name: RouteN.ATCS.EEHome.n });
        } else {
          this.$router.push({ name: RouteN.ATCS.DashboardMain.n });
        }
      }
    })
  }

}
